import { useTheme } from '@emotion/react';
import { IconClose } from '@hubble/icons/web';
import React__default from 'react';
import { Button } from '../Button/index.js';
import { Flex } from '../Flex/index.js';
import { Text } from '../Text/index.js';
import { TOASTER_DURATIONS } from './constants.js';
import { ToastContainer, ToastContent } from './styles.js';
import { jsx, jsxs } from '@emotion/react/jsx-runtime';

const Toast = ({
  'data-testid': dataTestId = 'toast',
  message,
  transitionStatus,
  hideToast,
  onDismiss,
  uuid
}) => {
  const {
    translate
  } = useTheme();
  const toastTimeout = React__default.useRef(null);
  React__default.useEffect(() => {
    if (hideToast) {
      toastTimeout.current = setTimeout(() => {
        hideToast(uuid);
      }, TOASTER_DURATIONS.timeout);
      return () => clearTimeout(toastTimeout.current);
    }
  }, [uuid, hideToast]);
  return jsx(ToastContainer, {
    transitionStatus: transitionStatus,
    role: "alert",
    "aria-live": "polite",
    children: jsxs(ToastContent, {
      transitionStatus: transitionStatus,
      children: [jsx(Text.Body, {
        as: "div",
        bold: true,
        size: "sm",
        mr: 2,
        "data-testid": `${dataTestId}-message`,
        children: message
      }), jsx(Flex, {
        shrink: 0,
        children: jsx(Button.Tertiary, {
          "data-testid": `${dataTestId}-close-button`,
          onClick: () => {
            hideToast === null || hideToast === void 0 ? void 0 : hideToast(uuid);
            onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
          },
          icon: jsx(IconClose, {}),
          size: "sm",
          "aria-label": translate('Toast.close')
        })
      })]
    })
  });
};

export { Toast };
